/**
 * Source code card line numbers.
 * From https://ghost.org/tutorials/code-syntax-highlighting/ but gulp can't build js with new type functions
 * addEventListener('DOMContentLoaded', (event) => {... }; So I change it to a named function.
 * This script is needed in order for Prism.js to know which code blocks require line numbers
 *
 */

window.addEventListener('DOMContentLoaded', showLineNumbers);

function showLineNumbers(event) {
    document.querySelectorAll('pre[class*=language-]').forEach(function (node) {
        node.classList.add('line-numbers');
    });
    Prism.highlightAll();
}